/** "$12,500" (engine text writes plain "$12500"). */
export const money = (n: number) => `$${Math.floor(n).toLocaleString('en-US')}`;

/** Adds commas to every dollar amount in a line of engine text. */
export const withCommas = (text: string) => text.replace(/\$(\d{4,})/g, (_, d: string) => money(Number(d)));
